module.exports = __webpack_public_path__ + "img/4096966b0cb46af119e50ef92deb73cc.0173df5f.png";